import {getLocation} from 'common/util/url';

import {UrlManager} from './types';

export class WindowUrlManager implements UrlManager {
  getPath() {
    return getLocation().pathname;
  }

  getHash() {
    return getLocation().hash;
  }

  getQueryStringParam(paramName: string) {
    let paramVal = new URLSearchParams(getLocation().search).get(paramName);
    if (paramVal === null) {
      paramVal = new URLSearchParams(getLocation().hash).get(paramName); // wtf dashboards
    }
    return paramVal;
  }

  getLocation() {
    return getLocation();
  }

  setLocation(url) {
    window.location.assign(url);
  }

  openInNewTab(...args) {
    window.open(...args);
  }

  historyReplaceState(data: any, unused: string, url: string | URL) {
    window.history.replaceState(data, unused, url);
  }

  historyPushState(data: any, unused: string, url: string | URL) {
    window.history.pushState(data, unused, url);
  }
}
